<template>
    <v-row no-gutters align="center" :class="data.class">
        <v-col cols="12" >
            <v-progress-linear height="2" color="primary" model-value="100"></v-progress-linear>
        </v-col>
        <v-col cols="12" v-for="(item, index) in data.list" :key="index" >
            <v-container class="mx-auto py-7 text-start text-md-center">
                <v-row align="center">
                    <v-col cols="12" class="mx-auto text-start">
                        <div class="mx-auto w-100 maxw-650">
                            <h2 class="text-md-h3 text-h4 font-weight-regular">{{ item.n ?? index+1 }}. {{ item.title }}</h2>
                        </div>
                    </v-col>
                    <v-col cols="2" class="mx-auto"></v-col>
                    <v-col cols="8" class="mx-auto">
                       <p class="text">{{ item.text }}</p>
                    </v-col>
                </v-row>
            </v-container>
            <v-progress-linear height="2" color="primary" model-value="100"></v-progress-linear>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'NumericList',
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        panel: [],
    }),
    mounted(){
        if(this.data.open){
            this.panel = [0]
        }
    }
}
</script>

<style>

.maxw-650{
    max-width: 650px;
}

</style>